"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var loadCollections = function loadCollections(payload) {
  return {
    type: 'OLY_LOAD_COLLECTIONS',
    payload: payload
  };
};

var loadCollectionsSuccess = function loadCollectionsSuccess(payload) {
  return {
    type: 'OLY_LOAD_COLLECTIONS_SUCCESS',
    payload: payload
  };
};

var loadCollectionsError = function loadCollectionsError(error) {
  return {
    type: 'OLY_LOAD_COLLECTIONS_ERROR',
    payload: {
      error: error
    }
  };
};

var loadCollectionsReset = function loadCollectionsReset() {
  return {
    type: 'OLY_LOAD_COLLECTIONS_RESET'
  };
};

var loadCollection = function loadCollection(payload) {
  return {
    type: 'OLY_LOAD_COLLECTION',
    payload: payload
  };
};

var loadCollectionSuccess = function loadCollectionSuccess(payload) {
  return {
    type: 'OLY_LOAD_COLLECTION_SUCCESS',
    payload: payload
  };
};

var loadCollectionError = function loadCollectionError(error) {
  return {
    type: 'OLY_LOAD_COLLECTION_ERROR',
    payload: {
      error: error
    }
  };
};

var loadCollectionReset = function loadCollectionReset() {
  return {
    type: 'OLY_LOAD_COLLECTION_RESET'
  };
};

var createCollection = function createCollection(payload) {
  return {
    type: 'OLY_CREATE_COLLECTION',
    payload: payload
  };
};

var createCollectionSuccess = function createCollectionSuccess() {
  return {
    type: 'OLY_CREATE_COLLECTION_SUCCESS'
  };
};

var createCollectionError = function createCollectionError(error) {
  return {
    type: 'OLY_CREATE_COLLECTION_ERROR',
    payload: {
      error: error
    }
  };
};

var createCollectionReset = function createCollectionReset() {
  return {
    type: 'OLY_CREATE_COLLECTION_RESET'
  };
};

var editCollection = function editCollection(payload) {
  return {
    type: 'OLY_EDIT_COLLECTION',
    payload: payload
  };
};

var editCollectionSuccess = function editCollectionSuccess() {
  return {
    type: 'OLY_EDIT_COLLECTION_SUCCESS'
  };
};

var editCollectionError = function editCollectionError(error) {
  return {
    type: 'OLY_EDIT_COLLECTION_ERROR',
    payload: {
      error: error
    }
  };
};

var editCollectionReset = function editCollectionReset() {
  return {
    type: 'OLY_EDIT_COLLECTION_RESET'
  };
};

var deleteCollection = function deleteCollection(payload) {
  return {
    type: 'OLY_DELETE_COLLECTION',
    payload: payload
  };
};

var deleteCollectionSuccess = function deleteCollectionSuccess() {
  return {
    type: 'OLY_DELETE_COLLECTION_SUCCESS'
  };
};

var deleteCollectionError = function deleteCollectionError(error) {
  return {
    type: 'OLY_DELETE_COLLECTION_ERROR',
    payload: {
      error: error
    }
  };
};

var deleteCollectionReset = function deleteCollectionReset() {
  return {
    type: 'OLY_DELETE_COLLECTION_RESET'
  };
};

var _default = {
  loadCollections: loadCollections,
  loadCollectionsSuccess: loadCollectionsSuccess,
  loadCollectionsError: loadCollectionsError,
  loadCollectionsReset: loadCollectionsReset,
  loadCollection: loadCollection,
  loadCollectionSuccess: loadCollectionSuccess,
  loadCollectionError: loadCollectionError,
  loadCollectionReset: loadCollectionReset,
  createCollection: createCollection,
  createCollectionSuccess: createCollectionSuccess,
  createCollectionError: createCollectionError,
  createCollectionReset: createCollectionReset,
  deleteCollection: deleteCollection,
  deleteCollectionSuccess: deleteCollectionSuccess,
  deleteCollectionError: deleteCollectionError,
  deleteCollectionReset: deleteCollectionReset,
  editCollection: editCollection,
  editCollectionSuccess: editCollectionSuccess,
  editCollectionError: editCollectionError,
  editCollectionReset: editCollectionReset
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map